import { combineReducers } from "@reduxjs/toolkit";

import { MultiSearchSource } from "@/shop/types/multiSearch";

import { default as query } from "./query/reducer";
import { createMultiSearchInitialState, createMultiSearchResultReducer } from "./results/reducer";

const results = combineReducers({
  [MultiSearchSource.Parts]: createMultiSearchResultReducer(createMultiSearchInitialState(MultiSearchSource.Parts)),
  [MultiSearchSource.OriginalSupply]: createMultiSearchResultReducer(createMultiSearchInitialState(MultiSearchSource.OriginalSupply)),
  [MultiSearchSource.Orders]: createMultiSearchResultReducer(createMultiSearchInitialState(MultiSearchSource.Orders)),
  [MultiSearchSource.Quotes]: createMultiSearchResultReducer(createMultiSearchInitialState(MultiSearchSource.Quotes)),
  [MultiSearchSource.IBase]: createMultiSearchResultReducer(createMultiSearchInitialState(MultiSearchSource.IBase)),
  [MultiSearchSource.FrsProduct]: createMultiSearchResultReducer(createMultiSearchInitialState(MultiSearchSource.FrsProduct)),
  [MultiSearchSource.CeSparepart]: createMultiSearchResultReducer(createMultiSearchInitialState(MultiSearchSource.CeSparepart)),
  [MultiSearchSource.FavoritList]: createMultiSearchResultReducer(createMultiSearchInitialState(MultiSearchSource.FavoritList)),
  [MultiSearchSource.Service]: createMultiSearchResultReducer(createMultiSearchInitialState(MultiSearchSource.Service)),
  [MultiSearchSource.ToscotecSp]: createMultiSearchResultReducer(createMultiSearchInitialState(MultiSearchSource.ToscotecSp))
});

export default combineReducers({
  query,
  results
});
